import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "icon-popup" }
const _hoisted_6 = { class: "icon-first" }
const _hoisted_7 = { class: "icon-last icon-last" }
const _hoisted_8 = { class: "form-inline" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["value"]

import { defineAsyncComponent } from 'vue';
import { icon_bar_status, select_icon, } from "@/composables/common/flagIcon"
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexIcoicon',
  setup(__props) {

const AbstractIcon = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/AbstractIcon.vue"))
const AnimalIcon = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/AnimalIcon.vue"))
const BrandIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/BrandIcons.vue"))
const BusinessIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/BusinessIcons.vue"))
const ChartIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/ChartIcons.vue"))
const ConstructionIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/ConstructionIcons.vue"))
const CurrencyIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/CurrencyIcons.vue"))
const DeviceIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/DeviceIcons.vue"))
const DirectionalIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/DirectionalIcons.vue"))
const EducationIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/EducationIcons.vue"))
const FiletypeIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/FiletypeIcons.vue"))
const EmoticonIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/EmoticonIcons.vue"))
const FoodIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/FoodIcons.vue"))
const KidsIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/KidsIcons.vue"))
const LawIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/LawIcons.vue"))
const MathematicalIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/MathematicalIcons.vue"))
const MedicalIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/MedicalIcons.vue"))
const MobileIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/MobileIcons.vue"))
const MultimediaIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/MultimediaIcons.vue"))
const PaymentIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/PaymentIcons.vue"))
const PersonIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/PersonIcons.vue"))
const SearchIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/SearchIcons.vue"))
const SocialIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/SocialIcons.vue"))
const SportIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/SportIcons.vue"))
const TextIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/TextIcons.vue"))
const TransportIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/TransportIcons.vue"))
const TravelIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/TravelIcons.vue"))
const WeatherIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/WeatherIcons.vue"))
const WebIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/WebIcons.vue"))

function icon_bar(icon: string) {
    select_icon.value.class = 'icofont icofont-' + icon;
    select_icon.value.tag = '<i class="icofont icofont-' + icon + '"></i>';
    icon_bar_status.value = true;
}
function close_icon_bar() {
    icon_bar_status.value = false;
}
function copy_icon() {
    toast.info('Code Copied to clipboard! ', {
        hideProgressBar: true, autoClose: 2000, theme: 'colored', position: 'bottom-right',
    });
    navigator.clipboard.writeText(select_icon.value.tag);
    document.execCommand('copy');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(AbstractIcon), { onSelected: icon_bar }),
        _createVNode(_unref(AnimalIcon), { onSelected: icon_bar }),
        _createVNode(_unref(BrandIcons), { onSelected: icon_bar }),
        _createVNode(_unref(BusinessIcons), { onSelected: icon_bar }),
        _createVNode(_unref(ChartIcons), { onSelected: icon_bar }),
        _createVNode(_unref(ConstructionIcons), { onSelected: icon_bar }),
        _createVNode(_unref(CurrencyIcons), { onSelected: icon_bar }),
        _createVNode(_unref(DeviceIcons), { onSelected: icon_bar }),
        _createVNode(_unref(DirectionalIcons), { onSelected: icon_bar }),
        _createVNode(_unref(EducationIcons), { onSelected: icon_bar }),
        _createVNode(_unref(EmoticonIcons), { onSelected: icon_bar }),
        _createVNode(_unref(FiletypeIcons), { onSelected: icon_bar }),
        _createVNode(_unref(FoodIcons), { onSelected: icon_bar }),
        _createVNode(_unref(KidsIcons), { onSelected: icon_bar }),
        _createVNode(_unref(LawIcons), { onSelected: icon_bar }),
        _createVNode(_unref(MathematicalIcons), { onSelected: icon_bar }),
        _createVNode(_unref(MedicalIcons), { onSelected: icon_bar }),
        _createVNode(_unref(MobileIcons), { onSelected: icon_bar }),
        _createVNode(_unref(MultimediaIcons), { onSelected: icon_bar }),
        _createVNode(_unref(PaymentIcons), { onSelected: icon_bar }),
        _createVNode(_unref(PersonIcons), { onSelected: icon_bar }),
        _createVNode(_unref(SearchIcons), { onSelected: icon_bar }),
        _createVNode(_unref(SocialIcons), { onSelected: icon_bar }),
        _createVNode(_unref(SportIcons), { onSelected: icon_bar }),
        _createVNode(_unref(TextIcons), { onSelected: icon_bar }),
        _createVNode(_unref(TransportIcons), { onSelected: icon_bar }),
        _createVNode(_unref(TravelIcons), { onSelected: icon_bar }),
        _createVNode(_unref(WeatherIcons), { onSelected: icon_bar }),
        _createVNode(_unref(WebIcons), { onSelected: icon_bar })
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["icon-hover-bottom p-fixed fa-fa-icon-show-div", { 'opecity-0': !_unref(icon_bar_status) }]),
      style: _normalizeStyle([_unref(icon_bar_status) ? { 'display': 'block' } : { 'display': 'none' }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "close-icon",
              onClick: close_icon_bar
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "icofont icofont-close" }, null, -1)
            ])),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("i", {
                class: _normalizeClass(["fa-2x", [_unref(select_icon).class]])
              }, null, 2)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "icon-class" }, [
              _createElementVNode("label", { class: "icon-title" }, "Class"),
              _createElementVNode("span", null, "icon-drupal")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _cache[1] || (_cache[1] = _createElementVNode("label", { class: "icon-title" }, "Markup", -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("input", {
                    class: "inp-val form-control m-r-10",
                    type: "text",
                    ref: "text",
                    value: _unref(select_icon).tag
                  }, null, 8, _hoisted_10),
                  _createElementVNode("button", {
                    class: "btn btn-primary notification",
                    onClick: copy_icon
                  }, "Copy text")
                ])
              ])
            ])
          ])
        ])
      ])
    ], 6)
  ], 64))
}
}

})